import * as React from 'react';
import Checkbox from 'src/components/FormElements/Checkbox';
import { StatusCode } from '../types';

type StatusItem = {
  code: StatusCode;
  label: string;
};

type StatusSelectProps = {
  value: StatusCode[];
  onChange: (value: StatusCode[]) => void;
};

const statuses: StatusItem[] = [
  { code: 'G', label: 'Godkendt' },
  { code: 'K', label: 'Aflyst' },
  { code: 'S', label: 'Afsluttet' },
];

const StatusSelect = ({ value, onChange }: StatusSelectProps) => (
  <div className="flex flex-column">
    {statuses.map((status) => (
      <Checkbox
        key={status.code}
        className="mt1"
        checked={value.indexOf(status.code) !== -1}
        onChange={() => {
          const index = value.indexOf(status.code);
          if (index > -1) {
            const withoutCode = value.filter((code) => code !== status.code);
            onChange(withoutCode);
          } else {
            onChange(value.concat(status.code));
          }
        }}
      >
        {status.label}
      </Checkbox>
    ))}
  </div>
);

export default StatusSelect;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/StatusSelect.tsx